import { Anchor } from '@vtex/admin-ui'
import { useFormState } from '@vtex/admin-ui-form'
import { useCallback, useEffect } from 'react'
import { useIntl } from 'react-intl'
import type { UTMICampaign as UTM } from 'typings'
import { DrawerFormType } from '.'
import {
  CancelButton,
  DismissButton,
  Drawer,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerSubtitle,
  DrawerTitle,
  SaveButton,
  type UseDrawerStateReturn,
} from '../../../Drawer'
import { UTMField } from '../UTM/UTMField'
import { messages } from './messages'

interface Props {
  state: UseDrawerStateReturn
  initialConfig: UTM
  onSave: (config: DrawerFormType) => void
}

export function Editor(props: Props) {
  const { state, initialConfig, onSave } = props

  const isCreating = !initialConfig.utmiCampaign.length

  const { hide } = state

  const { $t } = useIntl()

  const drawerForm = useFormState<DrawerFormType>({
    defaultValues: initialConfig,
  })

  const handleSave = async () => {
    onSave(drawerForm.getValues())
    hide()
  }

  const setInitialConfig = useCallback(() => {
    drawerForm.reset(initialConfig)
  }, [initialConfig, drawerForm])

  useEffect(() => {
    state.open && setInitialConfig()
  }, [setInitialConfig, state.open])

  return (
    <Drawer state={state}>
      <DrawerHeader>
        <DrawerTitle>{$t(messages.title)}</DrawerTitle>
        <DrawerSubtitle>
          {$t(messages.subtitle, {
            a: (content: any) => (
              <Anchor target="_blank" href={$t(messages.moreInformation)}>
                {content}
              </Anchor>
            ),
          })}
        </DrawerSubtitle>
        <DismissButton onHide={state.hide} />
      </DrawerHeader>
      <DrawerContent>
        <UTMField
          name="utmiCampaign"
          label={$t(messages.campaign)}
          state={drawerForm}
        />
      </DrawerContent>
      <DrawerFooter>
        <CancelButton onClick={hide} />
        <SaveButton isCreating={isCreating} onClick={handleSave} />
      </DrawerFooter>
    </Drawer>
  )
}
